import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=8fc408b2&scoped=true&"
import script from "./studentCard.vue?vue&type=script&lang=js&"
export * from "./studentCard.vue?vue&type=script&lang=js&"
import style0 from "./studentCard.vue?vue&type=style&index=0&id=8fc408b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc408b2",
  null
  
)

export default component.exports